const AboutSection = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="text-sm text-gray-600 uppercase tracking-wider">
            Wie We Zijn
          </span>
        </div>

        <div className="bg-white rounded-3xl p-12 lg:p-20 shadow-sm">
          <p className="text-3xl lg:text-4xl text-gray-900 font-medium leading-relaxed text-center" style={{ fontFamily: 'serif', lineHeight: '1.8' }}>
            Bij NGP Renovatieproject combineren we vakmanschap met innovatie om uw visie tot leven te brengen. Met jarenlange ervaring in renovatie en afwerking, transformeren we ruimtes met precisie en aandacht voor detail. Elk project is uniek en verdient een persoonlijke aanpak 🏗️
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;